<script lang="ts">
    import {getLocalization} from 'src/core';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {exists} from 'shared/utils/custom-utils';

    export let buttonId: string | null = null;

    const localize = getLocalization();
    let buttonElement: HTMLButtonElement;

    const handleCopyClick = () => {
        if (!exists(navigator.clipboard) || !window.isSecureContext) {
            const textArea = document.createElement('textarea');
            textArea.value = buttonElement.innerText;

            textArea.style.position = 'absolute';
            textArea.style.left = '-999999px';

            document.body.prepend(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
            } finally {
                textArea.remove();
            }

            return;
        }

        navigator.clipboard.writeText(buttonElement.innerText);
    };
</script>

<button class="kp-click-copy"
        id={buttonId}
        bind:this={buttonElement}
        on:click={handleCopyClick}
        use:tooltip={localize(/* @kp-localization commons.ClickToCopy */ 'commons.ClickToCopy')}>

    <slot/>
</button>

<style lang="less">
    .kp-click-copy {
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
    }
</style>